// extracted by mini-css-extract-plugin
module.exports = {"rating":"styles_rating__BeaZq","scoreOn":"styles_scoreOn__i0XCP","scoreOff":"styles_scoreOff__rhmLt"};